var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListenAudioOn(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C12.2091 13 14 11.2091 14 9C14 6.79086 12.2091 5 10 5C7.79086 5 6 6.79086 6 9C6 11.2091 7.79086 13 10 13Z",
    fill: "#00495F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3899 15.56C14.7099 14.7 12.5299 14 9.99994 14C7.46994 14 5.28994 14.7 3.60994 15.56C3.122 15.8113 2.71324 16.1929 2.42904 16.6625C2.14484 17.132 1.99631 17.6712 1.99994 18.22V21H17.9999V18.22C17.9999 17.1 17.3899 16.07 16.3899 15.56ZM20.3599 1L18.9499 2.41C20.2611 3.72368 20.9976 5.50393 20.9976 7.36C20.9976 9.21607 20.2611 10.9963 18.9499 12.31L20.3599 13.72C21.1969 12.8858 21.8609 11.8945 22.314 10.8032C22.7671 9.71177 23.0003 8.5417 23.0003 7.36C23.0003 6.1783 22.7671 5.00823 22.314 3.91685C21.8609 2.82547 21.1969 1.83424 20.3599 1Z",
    fill: "#00495F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5409 10.9001C18.4775 9.96205 19.0036 8.69066 19.0036 7.36508C19.0036 6.0395 18.4775 4.76811 17.5409 3.83008L16.1309 5.24008C16.6927 5.80258 17.0082 6.56508 17.0082 7.36008C17.0082 8.15508 16.6927 8.91758 16.1309 9.48008L17.5409 10.9001Z",
    fill: "#00495F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenAudioOn);
export default __webpack_public_path__ + "static/media/listenAudioOn.b707f21f0c1d053d1ae36adac32ba12c.svg";
export { ForwardRef as ReactComponent };